import { useSelector } from "react-redux";
import { useGetPricingTypes } from "../../../../../hooks/api/queries";

export const usePricingForm = () => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { data: pricingTypes, isLoading: isLoadingPricingTypes } =
    useGetPricingTypes();

  return { storeList, pricingTypes, isLoading: isLoadingPricingTypes };
};
